import useMultiNotification from "./hooks/useNotification";
import RoutesWrapper from "./routes";

function TwingeApp() {
  const { contextHolder } = useMultiNotification();
  return (
    <>
      {contextHolder}
      <RoutesWrapper />
    </>
  );
}

export default TwingeApp;
